import { render, staticRenderFns } from "./TDteacher.vue?vue&type=template&id=ea6ab988&scoped=true"
import script from "./TDteacher.vue?vue&type=script&lang=js"
export * from "./TDteacher.vue?vue&type=script&lang=js"
import style0 from "./TDteacher.vue?vue&type=style&index=0&id=ea6ab988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6ab988",
  null
  
)

export default component.exports